import {BaseBbanValidator} from './validator';

export {BbanDirective} from './directive';
export {BbanPipe} from './pipe';

export const BBAN_VALIDATORS = [BaseBbanValidator];
